import styled from 'styled-components';

const CollapseHeader = styled.div`
	box-sizing: border-box;
	width: 100%;
`;
export default CollapseHeader;
